import React, { type ComponentProps, useRef } from 'react';
import { StyleSheet, View, type ViewInstance } from 'react-native';

import { Button, theme, useHovered, webOnlyStyles } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroButton = (props: Props) => {
  const { hoveredStyle, style, ...buttonProps } = props;

  // ─── Refs ────────────────────────────────────────────────────────────

  const buttonRef = useRef<ViewInstance>(null);

  // ─── Derived ─────────────────────────────────────────────────────────

  const isHovered = useHovered(buttonRef);

  // ─── Styles ──────────────────────────────────────────────────────────

  const buttonStyles = [styles.button, style, isHovered ? hoveredStyle : undefined];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <Button
        ref={buttonRef}
        {...buttonProps}
        size="large-wide"
        style={buttonStyles}
        width="100%"
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  button: {
    paddingHorizontal: theme.spacing['4'],
    ...webOnlyStyles({
      transition: `background-color ${theme.transitions.base}ms, border-color ${theme.transitions.base}ms, color ${theme.transitions.base}ms`,
    }),
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof Button>, 'size' | 'width'> & {
  hoveredStyle?: ComponentProps<typeof Button>['style'];
};
